/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.Item.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.ItemDetailsLayout.Item.View", ["require", "exports", "sc-pageprinter-item-details-default.tpl", "Backbone", "SuiteCommerce.PagePrinter.Common.Utils", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Configuration", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper", "SuiteCommerce.PagePrinter.ItemDetailsLayout.FieldsHelpersCatalog", "underscore", "SuiteCommerce.PagePrinter.Instrumentation"], function (require, exports, itemDetailsItemTemplate, Backbone_1, Utils_1, ItemDetailsLayout_Configuration_1, ItemDetailsLayout_Helper_1, ItemDetailsLayout_FieldsHelpersCatalog_1, _, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemDetailsItemView = /** @class */ (function (_super) {
        __extends(ItemDetailsItemView, _super);
        function ItemDetailsItemView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = itemDetailsItemTemplate;
            _this.fields = ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.itemFields;
            ItemDetailsLayout_FieldsHelpersCatalog_1.HelpersCatalog.initializeHelpers();
            _this.logQuantityOfAdditionalFields();
            return _this;
        }
        ItemDetailsItemView.prototype.getContext = function () {
            return {
                item: this.model,
                showHeader: !!ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyLogoURL ||
                    !!ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyInformation,
                showCompanyLogo: !!ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyLogoURL,
                companyLogo: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyLogoURL,
                showContactInfo: !!ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyInformation,
                contactInfo: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.companyInformation,
                showUrl: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.isUrlDisplayedAsText ||
                    ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.isUrlDisplayedAsTextAndQr,
                showQr: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.isUrlDisplayedAsQr ||
                    ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.isUrlDisplayedAsTextAndQr,
                url: location.origin + '/' + this.model.url,
                name: this.model.name,
                image: this.model.thumbnail,
                showPrice: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.showPrice,
                priceLabel: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.priceLabel,
                hasPriceRange: this.model.hasPriceRange,
                price: this.model.price,
                showSku: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.showSku,
                skuLabel: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.skuLabel,
                sku: this.model.sku,
                showRating: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.productReviews &&
                    ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.showRating,
                ratingLabel: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.ratingLabel,
                rating: this.model.rating,
                hasRating: this.model.rating > 0,
                maxRating: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.productReviewsMaxRate,
                showCombinations: this.model.combinations.body.length > 0,
                combinationsLabel: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.matrixChildSectionLabel,
                combinations: this.model.combinations,
                showNotesFromTheSupplier: !!ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.notesFromTheSupplier,
                notesFromTheSupplier: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.notesFromTheSupplier,
                showAdditionalFields: this.fields.length > 0,
                AdditionalFields: this.fields,
                requireLoginForPricingMessage: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.requireLoginForPricingMessage,
                isEnabledLoginToSeePrice: Utils_1.Utils.hidePrices(),
                loginToSeePriceUrl: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.getUrlLogin,
                showQuantityPricing: ItemDetailsLayout_Configuration_1.ItemDetailsConfiguration.isEnabledQuantityPricing &&
                    this.model.price &&
                    this.model.price.priceSchedule &&
                    this.model.price.priceSchedule.length > 0,
            };
        };
        ItemDetailsItemView.prototype.logQuantityOfAdditionalFields = function () {
            if (this.fields.length > 0) {
                var additionalFieldsByTypes = this.getAdditionalFieldsOfItemLog();
                if (additionalFieldsByTypes) {
                    var log = Instrumentation_1.default.getLog('usageOfKindOfAdditionalFields');
                    log.setParameters({
                        activity: 'Quantity of Additional Fields',
                        subType: additionalFieldsByTypes,
                    });
                    log.submit();
                }
            }
        };
        ItemDetailsItemView.prototype.getAdditionalFieldsOfItemLog = function () {
            var _this = this;
            var itemAdditionalFields = _.filter(this.fields, function (field) {
                return _this.model.get(field.fieldId);
            });
            var itemAdditionalFieldsCountedByTypes = _.countBy(itemAdditionalFields, function (field) {
                return field.type;
            });
            return (ItemDetailsLayout_Helper_1.FieldType['Check/Cross'] + ":" + itemAdditionalFieldsCountedByTypes[ItemDetailsLayout_Helper_1.FieldType['Check/Cross']] + ";" +
                (ItemDetailsLayout_Helper_1.FieldType.Date + ":" + itemAdditionalFieldsCountedByTypes[ItemDetailsLayout_Helper_1.FieldType.Date] + ";") +
                (ItemDetailsLayout_Helper_1.FieldType.QRCode + ":" + itemAdditionalFieldsCountedByTypes[ItemDetailsLayout_Helper_1.FieldType.QRCode] + ";") +
                (ItemDetailsLayout_Helper_1.FieldType.Text + ":" + itemAdditionalFieldsCountedByTypes[ItemDetailsLayout_Helper_1.FieldType.Text] + ";") +
                ("totalAmount:" + itemAdditionalFields.length));
        };
        return ItemDetailsItemView;
    }(Backbone_1.View));
    exports.ItemDetailsItemView = ItemDetailsItemView;
});
